import React from 'react'

export const llamadasHeader = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" enableBackground="new 0 0 40 40" xmlSpace="preserve">
<g>
	<g>
		<path className="borderIconHeader" d="M35.7,38.4c-13.1,0-23.8-10.7-23.8-23.8c0-1.5,1.3-2.8,2.8-2.8h4.6c1.5,0,2.8,1.3,2.8,2.8c0,1.5,0.2,2.9,0.7,4.2
			c0.3,1,0.1,2.1-0.7,2.9L20,23.8c1.6,2.7,3.9,5,6.6,6.6l2.1-2.1c0.5-0.5,1.2-0.8,2-0.8c0.3,0,0.6,0,0.9,0.1
			c1.3,0.4,2.8,0.7,4.2,0.7c1.5,0,2.8,1.3,2.8,2.8v4.6C38.5,37.2,37.3,38.4,35.7,38.4z"/>
	</g>
</g>
<g>
	<g>
		<path className="iconHeader" d="M18.1,23.5c1.9,3.7,4.9,6.8,8.7,8.7l2.9-2.9c0.4-0.4,0.9-0.5,1.3-0.3c1.5,0.5,3.1,0.8,4.7,0.8
			c0.7,0,1.3,0.6,1.3,1.3v4.6c0,0.7-0.6,1.3-1.3,1.3c-12.3,0-22.3-10-22.3-22.3c0-0.7,0.6-1.3,1.3-1.3h4.6c0.7,0,1.3,0.6,1.3,1.3
			c0,1.6,0.3,3.2,0.7,4.7c0.1,0.5,0,1-0.3,1.3L18.1,23.5z"/>
	</g>
</g>
</svg>

export const mensajesHeader = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" enableBackground="new 0 0 40 40" xmlSpace="preserve">
<g>
	<g>
		<g>
			<path className="borderIconHeader" d="M39,29.7c0-2.2-1.3-4.3-3.6-5.7c0,0-0.1,0-0.1,0c0-0.2,0-0.4,0-0.6c0-5.9-6.3-10.7-14.1-10.7c-7.8,0-14.1,4.8-14.1,10.7
				c0,3.3,1.9,6.3,5.2,8.3c-0.2,0.3-0.4,0.7-0.8,1.2c-0.6,0.6-0.8,1.5-0.5,2.2c0.3,0.8,1,1.3,1.9,1.4c0.1,0,0.1,0,0.2,0
				c1.3,0,4.5-0.5,7.3-2.4c0.3,0,0.6,0,0.8,0c0.1,0,0.2,0,0.4,0c0.1,0.1,0.1,0.2,0.2,0.2c1.8,1.7,4.6,2.8,7.5,2.8c0.1,0,0.2,0,0.3,0
				c0.9,0.7,2.5,1.5,5.2,1.7c0,0,0.1,0,0.1,0c0.5,0,1-0.3,1.3-0.8c0.3-0.5,0.2-1.2-0.2-1.6c-0.2-0.2-0.4-0.5-0.7-1
				C37.7,34,39,31.9,39,29.7z"/>
		</g>
	</g>
</g>
<g>
	<g>
		<path className="iconHeader" d="M21.3,14.1c-7,0-12.6,4.1-12.6,9.3c0,3.2,2.2,6,5.6,7.7c-0.1,0.5-0.5,1.5-1.5,2.8c-0.3,0.3-0.4,1.1,0.4,1.2
			c0.9,0,4.1-0.4,6.9-2.5c0.4,0,0.8,0,1.3,0c7,0,12.6-4.2,12.6-9.3S28.3,14.1,21.3,14.1z"/>
		<g>
			<path className="iconHeader" d="M37.6,29.7c0-1.8-1.1-3.4-2.9-4.5c-0.8,4.3-5.9,7.7-11.8,8c1.5,1.4,3.9,2.3,6.5,2.3c0.3,0,0.6,0,0.8,0
				c0.5,0.5,1.8,1.5,4.8,1.8c-0.3-0.4-1.1-1.3-1.3-2.6C36,33.6,37.6,31.8,37.6,29.7z"/>
		</g>
	</g>
</g>
</svg>

export const facebookHeader = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" enableBackground="new 0 0 40 40" xmlSpace="preserve">
<g>
	<g>
		<path className="borderIconHeader" d="M21.4,38.9c-0.9,0-1.9-0.6-1.9-1.5V28h-1.9c-0.9,0-1.2-1-1.2-1.8v-4.5c0-0.9,0.4-1.5,1.2-1.5h2.3c0,0,0-1.1,0-1.6
			c0-0.6,0-1.3,0.2-1.9c0.3-1.9,1.2-3.3,2.6-4.3c1.2-0.8,2.6-1.3,4.2-1.3h0.4c0.6,0,1.3,0,1.9,0.1h0.2c0.4,0,0.7,0.1,1,0.1h0.2
			c0.8,0.1,1.3,0.7,1.3,1.5v4c0,0.9-0.6,1.6-1.5,1.6h-1.6c-0.3,0-0.6,0-0.9,0c-0.2,0-0.3,0-0.4,0c0,0,0,0.1,0,0.2c0,0.4,0,1.6,0,1.6
			h2.8c0.4,0,0.9,0.2,1.2,0.5s0.4,0.8,0.4,1.2c-0.2,1.5-0.4,3.1-0.6,4.6c0,0.8-0.7,1.5-1.5,1.5h-2.6v9.4c0,0.9-0.3,1.5-1.2,1.5H21.4
			z"/>
		<path className="iconHeader" d="M27.9,16.8c0.8,0,1.5,0,2.3,0c0.1,0,0.2,0,0.3,0v-4c-0.4,0-0.8-0.1-1.3-0.1c-0.8,0-1.6-0.1-2.4-0.1
			c-1.2,0-2.3,0.3-3.3,1c-1.1,0.8-1.8,2-2,3.3c-0.1,0.6-0.1,1.1-0.1,1.7c0,0.9,0,1.8,0,2.7v0.3h-3.8v4.5h3.8v11.2H26V26.2h3.8
			c0.2-1.5,0.4-3,0.6-4.5c-0.3,0-0.6,0-0.9,0c-1.1,0-3.5,0-3.5,0s0-2.2,0-3.2C26.1,17.3,26.9,16.8,27.9,16.8z"/>
	</g>
</g>
</svg>

export const linkedinHeader = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" enableBackground="new 0 0 40 40" xmlSpace="preserve">
<g>
	<g>
		<g>
			<path className="borderIconHeader" d="M14.6,38.7c-0.8,0-1.8-0.5-1.8-1.3V21.9c0-0.8,0.8-1.4,1.6-1.4c-1.1-0.8-1.7-2-1.7-3.4c0-2.3,1.9-4.2,4.3-4.2
				s4.2,1.9,4.2,4.2c0,1.4-0.4,2.7-1.5,3.4c0.8,0,1.7,0.7,1.7,1.4v15.4c0,0.8-1.2,1.3-2,1.3H14.6z"/>
			<path className="iconHeader" d="M14.6,21.9h4.8v15.4h-4.8V21.9z M17,14.2c1.5,0,2.8,1.2,2.8,2.8c0,1.5-1.2,2.8-2.8,2.8
				c-1.5,0-2.8-1.2-2.8-2.8C14.2,15.5,15.5,14.2,17,14.2"/>
			<path className="borderIconHeader" d="M32.6,38.7c-0.8,0-1.1-0.5-1.1-1.3v-7.5c0-2.6-0.6-2.6-1.3-2.6c-0.7,0-1.6,0-1.6,2.5v7.6c0,0.8-0.6,1.3-1.4,1.3h-4.8
				c-0.8,0-2.4-0.5-2.4-1.3V21.9c0-0.8,0.2-2,1-2h6c0.4,0,0.8,0.5,1.1,0.8c0.9-0.5,2.1-0.8,3.5-0.8c7.2,0,7.2,6.5,7.2,8.9v8.5
				c0,0.8-0.6,1.3-1.4,1.3H32.6z"/>
			<path className="iconHeader" d="M22.4,21.9H27V24h0.1c0.6-1.2,2.2-2.5,4.5-2.5c4.9,0,5.7,3.2,5.7,7.3v8.5h-4.8v-7.5c0-1.8,0-4.1-2.5-4.1
				c-2.5,0-2.9,1.9-2.9,4v7.6h-4.8L22.4,21.9L22.4,21.9z"/>
		</g>
	</g>
</g>
</svg>

export const mailHeader = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" enableBackground="new 0 0 40 40" xmlSpace="preserve">
<path className="borderIconHeader" d="M13.4,38.5c-2.2,0-4-1.7-4-3.9l0-15.9c0-2.2,1.8-4,4-4h21.2c2.2,0,4,1.9,4,4.1v15.9c0,2.2-1.8,3.9-4,3.9H13.4z M33.3,33.2
	v-9.4l-8.6,5.4c-0.2,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.5-0.1-0.7-0.2l-8.6-5.4v9.4H33.3z M24,23.7l6-3.7H18L24,23.7z"/>
<path className="iconHeader" d="M34.6,16H13.4c-1.5,0-2.6,1.2-2.6,2.6l0,15.9c0,1.5,1.2,2.6,2.6,2.6h21.2c1.5,0,2.6-1.2,2.6-2.6V18.7
	C37.2,17.2,36.1,16,34.6,16z M34.6,34.5H13.4V21.3L24,27.9l10.6-6.6V34.5z M24,25.3l-10.6-6.6h21.2L24,25.3z"/>
</svg>

export const twitterHeader = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" enableBackground="new 0 0 40 40" xmlSpace="preserve">
<g>
	<g>
		<path className="borderIconHeader" d="M19,38.3c-3.2,0-6.2-0.9-8.9-2.5c-0.5-0.3-0.8-1-0.6-1.6c0.2-0.6,0.7-0.9,1.2-0.9c0,0,0.1,0,0.1,0c0.4,0,0.8,0.1,1.1,0.1
			c1.2,0,2.3-0.2,3.4-0.6c-1.6-0.9-2.6-2.4-3-3.8c-0.1-0.3-0.1-0.7,0.1-0.9c-0.4-0.4-0.7-0.8-1-1.3c-0.7-1.1-1-2.3-1-3.6
			c0-0.5,0.2-0.9,0.6-1.1c-0.2-0.4-0.3-0.8-0.4-1.2c-0.4-1.7-0.1-3.4,0.7-4.9c0.2-0.4,0.6-0.6,1-0.7c0,0,0.1,0,0.1,0
			c0.4,0,0.8,0.2,1,0.5c2.4,2.8,5.2,4.5,8.7,5c0-1.2,0.4-2.3,1-3.4c1.1-1.7,2.7-2.7,4.6-3.1C28.2,14,28.7,14,29,14
			c1.6,0,3,0.5,4.3,1.6c0.8-0.2,1.6-0.5,2.3-0.9c0,0,0.1-0.1,0.2-0.1c0,0,0.2-0.1,0.2-0.1v0c0,0,0.3-0.1,0.4-0.1
			c0.4,0,0.8,0.2,1.1,0.6c0.3,0.4,0.3,0.8,0.2,1.2c-0.1,0.1-0.1,0.3-0.2,0.4c0.3,0.1,0.5,0.2,0.7,0.5c0.4,0.5,0.4,1.2,0,1.7
			c0,0-0.5,0.7-0.6,0.8c-0.5,0.6-1.1,1.2-1.8,1.8c0,0.7,0,1.4-0.1,2c-0.2,1.8-0.7,3.6-1.5,5.2c-0.8,1.7-1.9,3.3-3.2,4.7
			c-2.2,2.3-5,3.8-8.2,4.6c-1,0.2-2.1,0.4-3.3,0.4C19.3,38.3,19.1,38.3,19,38.3z"/>
	</g>
</g>
<path className="iconHeader" d="M18.7,32.2c-2.8-0.1-4.6-2.1-5.1-3.8c0.8,0.2,1.6,0.1,2.3-0.1c0,0,0,0,0.1,0c-1.5-0.4-2.7-1.2-3.5-2.5
	C11.9,25,11.7,24,11.7,23c0.8,0.4,1.6,0.6,2.4,0.7c-1.2-0.8-1.9-1.9-2.2-3.3c-0.3-1.4-0.1-2.7,0.6-3.9c2.9,3.5,6.7,5.4,11.2,5.7
	c0-0.2-0.1-0.4-0.1-0.6c-0.1-1.3,0.1-2.5,0.8-3.6c0.9-1.4,2.1-2.2,3.7-2.5c1.8-0.3,3.4,0.2,4.8,1.5c0.1,0.1,0.2,0.1,0.3,0.1
	c1.1-0.2,2.2-0.6,3.2-1.2c0,0,0,0,0.1,0c0,0,0,0,0,0c-0.4,1.3-1.2,2.2-2.3,3c1.1-0.1,2.1-0.4,3-0.8c0,0,0,0,0,0
	c-0.2,0.3-0.4,0.6-0.6,0.8c-0.6,0.7-1.2,1.3-2,1.9c-0.1,0-0.1,0.1-0.1,0.2c0,0.8,0,1.6-0.1,2.4c-0.2,1.7-0.7,3.3-1.4,4.8
	c-0.7,1.6-1.7,3-2.9,4.3c-2.1,2.1-4.6,3.5-7.5,4.2c-1,0.2-2,0.3-3,0.4c-3.1,0.1-6-0.7-8.7-2.3c0,0-0.1,0-0.1-0.1
	c1.9,0.2,3.7,0,5.4-0.8C17,33.4,17.9,32.9,18.7,32.2z"/>
</svg>

export const Animated_phone = <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	width="72px" height="72px" viewBox="0 0 72 72" enableBackground="new 0 0 72 72" xmlSpace="preserve">
		<path fill="#FFFFFF" d="M27.033,33.983c2.4,4.716,6.267,8.565,10.983,10.983l3.667-3.668c0.449-0.449,1.117-0.598,1.699-0.399
		c1.867,0.618,3.883,0.95,5.951,0.95C50.25,41.85,51,42.6,51,43.516v5.818C51,50.25,50.25,51,49.334,51
		C33.683,51,21,38.318,21,22.667C21,21.75,21.75,21,22.667,21H28.5c0.916,0,1.667,0.75,1.667,1.667c0,2.083,0.333,4.083,0.949,5.95
		c0.184,0.583,0.051,1.233-0.417,1.7L27.033,33.983z"/>
	</svg>


// WEBPACK FOOTER //
// ./src/Images/HeaderSVG.js